import { Routes, Route, useLocation } from "react-router-dom";
import './App.css'
import HeroIntro from "./components/HeroIntro";
import ContentIntel from "./components/ContentIntel";
import Branding from "./components/missions/Branding";
import { useEffect, useState } from "react";
import KumudBranding from "./components/missions/branding/KumudBranding";
import Blog1 from "./components/intel/Quick-fixes-to-improve-website-speed-and-user-engagement";
import Blog2 from "./components/intel/Website-audit-guide-10-step-checklist";
import Blog3 from "./components/intel/What-is-a-branding-kit-2026-guide";
import Blog4 from "./components/intel/Branding-design-mistakes-that-cost-you-later";
import Blog5 from "./components/intel/How-to-take-better-photos-on-iphone";
import Blog6 from "./components/intel/the-champagne-coffee-problems";
import Blog7 from "./components/intel/Manufacturing-challenges-ai-solutions-2026";
import Blog8 from "./components/intel/Business-without-social-media-presence";
import ContentMissions from "./components/ContentMission";
import ContentHello from "./components/hello/ContentHello";
import ContentLaunch from "./components/launch/ContentLaunch";
import { AnimatePresence } from "framer-motion";
import Website from "./components/missions/website/Website";
import ProductionPostProduction from "./components/missions/product-postProduction/ProductionPostProduction";
import Cybernetyx from "./components/missions/product-postProduction/Cybernetyx";
import SeoGeo from "./components/missions/seo-geo/SeoGeo";



export default function App() {
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
  const location = useLocation();
  useEffect(() => {
    const move = (e) => {
      setCursor({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);


  useEffect(() => {
    const titles = {
      "/": "Home | Two Light Years",
      "/intel": "Writings",
      "/missions": "Missions",
      "/hello": "Hello",
      "/launch": "Contact",
      "/branding": "Branding ",
      "/ui-ux": "UI/UX",
      "/seo-geo": "SEO & GEO",
      "/branding/kumudbranding": "Kumud Branding",

      "/intel/quick-fixes-to-improve-website-speed-and-user-engagement":
        "Quick Fixes to Improve Website Speed",
      "/intel/website-audit-guide-10-step-checklist":
        "Website Audit Guide – 10 Step Checklist",
      "/intel/what-is-a-branding-kit-2026-guide":
        "What Is a Branding Kit? (2026 Guide)",
      "/intel/branding-design-mistakes-that-cost-you-later":
        "Branding Design Mistakes That Cost You",
      "/intel/how-to-take-better-photos-on-iphone":
        "How to Take Better Photos on iPhone",
      "/intel/the-champagne-coffee-problems":
        "The Champagne  Coffee Problem - The Regular customer is getting penalized with long queues and inconsistent pricing.",
      "/intel/manufacturing-challenges-ai-solutions-2026":
        "Manufacturing Challenges in 2026 & How AI Is Solving Them",
      "/intel/business-without-social-media-presence":
        "What Does a Business Look Like Without Social Media Presence?",
    };

    document.title =
      titles[location.pathname] || "Two Light Years";
  }, [location.pathname]);


  return (

    <AnimatePresence mode="wait">
      <div
        className="cursor-dot"
        style={{
          left: cursor.x,
          top: cursor.y,
        }}
      />

      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HeroIntro />} />
        <Route path="/blogs" element={<ContentIntel />} />
        <Route path="/services" element={<ContentMissions />} />
        <Route path="/about" element={<ContentHello />} />
        <Route path="/contact" element={<ContentLaunch />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/ui-ux" element={<Website />} />
        <Route path="/seo-geo" element={<SeoGeo />} />
        <Route path="/production-post-production" element={<ProductionPostProduction />} />
        <Route path="/production-post-production/cybernetyx" element={<Cybernetyx />} />
        <Route path="/branding/kumudbranding" element={<KumudBranding />} />
        <Route path="/intel/quick-fixes-to-improve-website-speed-and-user-engagement" element={<Blog1 />} />
        <Route path="/intel/website-audit-guide-10-step-checklist" element={<Blog2 />} />
        <Route path="/intel/what-is-a-branding-kit-2026-guide" element={<Blog3 />} />
        <Route path="/intel/branding-design-mistakes-that-cost-you-later" element={<Blog4 />} />
        <Route path="/intel/how-to-take-better-photos-on-iphone" element={<Blog5 />} />
        <Route path="/intel/the-champagne-coffee-problems" element={<Blog6 />} />
        <Route path="/intel/manufacturing-challenges-ai-solutions-2026" element={<Blog7 />} />
        <Route path="/intel/business-without-social-media-presence" element={<Blog8 />} />



      </Routes>
    </AnimatePresence>
  );
}
